// Alert.js
import React, { useEffect } from 'react';
import './Alert.css';

const Alert = ({ message, duration = 5000, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className="alert">
      {message}
    </div>
  );
};

export default Alert;
